import React from 'react';

const NewUploadsSection = () => {
  const projects = [
    {
      image: '/images/project1.jpg',
      title: 'Modern Living Room Transformation',
      description: 'Complete interior painting with texture finish',
      date: 'January 2025'
    },
    {
      image: '/images/project2.jpg',
      title: 'Elegant Bedroom Makeover',
      description: 'Soft color palette with premium finishes',
      date: 'December 2024'
    },
    {
      image: '/images/project3.jpg',
      title: 'Contemporary Office Space',
      description: 'Professional painting for commercial property',
      date: 'December 2024'
    },
    {
      image: '/images/project4.jpg',
      title: 'Luxury Villa Exterior',
      description: 'Weather-resistant exterior painting',
      date: 'November 2024'
    },
    {
      image: '/images/project5.jpg',
      title: 'Kitchen Renovation',
      description: 'Complete kitchen remodeling with fresh paint',
      date: 'November 2024'
    },
    {
      image: '/images/project6.jpg',
      title: 'Restaurant Interior Design',
      description: 'Custom texture walls for dining ambiance',
      date: 'October 2024'
    }
  ];

  return (
    <section id="uploads" className="uploads-section section-padding">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Recent Projects</h2>
          <p className="section-subtitle">Our Latest Work</p>
        </div>

        <div className="projects-grid">
          {projects.map((project, index) => (
            <div key={index} className="project-card">
              <div className="project-image-wrapper">
                <img src={project.image} alt={project.title} className="project-image" />
                <div className="project-overlay">
                  <div className="project-date">{project.date}</div>
                </div>
              </div>
              <div className="project-info">
                <h3 className="project-title">{project.title}</h3>
                <p className="project-description">{project.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NewUploadsSection;